module.exports = __webpack_public_path__ + "img/profile_teo_au0.56bd84f7.jpg";